import type { ReactNode } from "react";

/**
 * Botón de carga para los pasos del asistente: el <input type="file"> va
 * encima del botón, transparente, así que el clic cae directo en el input
 * (sin depender del <label> que lo envuelve) y no se ve el control nativo
 * «Seleccionar archivo / Sin archivos seleccionados».
 */
export default function WizUpload({ label, children }: { label: string; children: ReactNode }) {
  return (
    <span className="wiz-upload">
      <span className="wiz-upload__btn" aria-hidden="true">{label}</span>
      {children}
    </span>
  );
}
